import React, { FC } from 'react';
import { WorkPackageItemContainer } from './styled';
import { WorkPackage } from '@bechtel/types';
import { includes } from 'lodash';
import { ErrorBoundary, WorkPackageItemCard, usePlanning, PlanningActionType } from '@bechtel/client-common';
import { PlanningWorkPackageSlider } from '../types';
interface ListItemProps {
  wp: WorkPackage;
  planningWorkPackageSlider: PlanningWorkPackageSlider;
}
export const ListItem: FC<ListItemProps> = ({ wp, planningWorkPackageSlider }) => {
  const { selectedWpList, planningDispatch } = usePlanning();
  const selected = includes(selectedWpList, wp.id);
  return (
    <WorkPackageItemContainer
      key={wp.id}
      data-testid={selected ? `workpackage-card-selected-list-${wp.id}` : `workpackage-card-unselected-list-${wp.id}`}
      onClick={() => {
        planningDispatch({
          type:
            planningWorkPackageSlider === PlanningWorkPackageSlider.Multiple
              ? PlanningActionType.MultiWorkPackageSelected
              : PlanningActionType.SingleWorkPackageSelected,
          payload: { selectedWpList: [wp.id] },
        });
      }}
      selected={selected}
      planningWorkPackageSlider={
        planningWorkPackageSlider ? planningWorkPackageSlider : PlanningWorkPackageSlider.Single
      }
    >
      <ErrorBoundary>
        <WorkPackageItemCard {...wp} />
      </ErrorBoundary>
    </WorkPackageItemContainer>
  );
};
